var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gondola-mini-logout"}},[_c('global-logout',{attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }